import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { DataContext } from 'providers/data';
import { itemProduct } from 'utils/typeServices';

import { ProductsIcs } from 'core/productsTemplate';

import BoxMui from '@mui/material/Box';
import Modal from 'components/views/Modals';
import Tooltip from 'components/views/Tooltip';
import Typography from '@mui/material/Typography';
import PriceCard from 'components/views/PriceCard';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { ButtonRectangle } from 'components/views/form/Button';

import CancelIcon from '@mui/icons-material/Cancel';

import { Box, BoxList, ButtonCustom, ContendModal } from './styles';

import { ReactComponent as IcNewProduct } from 'assets/icons/ic-new-product.svg';

type ParamsWithoutPlan = {
    title: string;
    covering: boolean;
}

type ParamsData = {
    cdQuotationItem: string;
    nrTypeProduct: number;
    cdQuotation: number | undefined;
    listWithoutPlan: Array<ParamsWithoutPlan>;
    recommended?: boolean;
    product: boolean;
    price: string;
    cents: string;
    priceYearly: string;
    vL_TOTAL: string;
    codPlane: number;
    VL_COMISSAO: number;
    percentageIndem: number;
    titleProduct: string;
    textTooltip?: string;
    isShowModal?: boolean;
    produtO_ATUAL: boolean;
    isWebView: boolean;
    dS_PRODUTO: Array<string>;
    isEv?: boolean;
    isLight?: boolean;
    activeLightIds?: Array<number>;
    productsCard?: Array<itemProduct>;
    handleActiveLightIds?: (listIds: Array<number>) => void;
    isOne?: boolean;
    isOneExist?: boolean;
}

const Card = ({ listWithoutPlan, product, codPlane, titleProduct, percentageIndem = 0, price, cents, priceYearly, cdQuotationItem, nrTypeProduct, cdQuotation, VL_COMISSAO, vL_TOTAL, produtO_ATUAL, isWebView, dS_PRODUTO, isEv = false, isLight = false, productsCard = [], activeLightIds = [], handleActiveLightIds, isOne = false, isOneExist = false }: ParamsData) => {
    const { pathname } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModalIsLight, setIsOpenModalIsLight] = useState(false);
    const [productsSeguro, setProductsSeguro] = useState<Array<String>>();

    const { selectedCar, dataValidateChoose, isPendingTicket, handlePostValidateChoose, handleProductCart, handlePostCreateChangeSolicitationPlatform, handleErrorTicketOpen, handlePostCancelChange } = useContext(DataContext);

    const handleStateActive = (CDOldActive: number, CDActive: number) => {
        let activeLightIdsAux = activeLightIds.filter((cdPrd) => cdPrd !== CDOldActive);
        activeLightIdsAux.push(CDActive);

        handleActiveLightIds && handleActiveLightIds(activeLightIdsAux);
    }

    const handlerHireValidate = () => {
        if (isLight) {
            setIsOpenModalIsLight(true);
        } else {
            handlerHire();
        }
    }

    const handlerHire = () => {
        if (pathname?.includes('troca-de-servico') && isPendingTicket) {
            handleErrorTicketOpen(true);
            return;
        }

        if (selectedCar && cdQuotation) {
            setIsLoading(true);

            if (pathname?.includes('troca-de-veiculo')) {
                handlePostCreateChangeSolicitationPlatform({
                    body: {
                        cD_PESSOA: selectedCar.CD_PESSOA,
                        cD_PEDIDO: selectedCar.CD_PEDIDO,
                        nR_PLATAFORMA: selectedCar.NR_PLATAFORMA,
                        cD_COTACAO: cdQuotation,
                    },
                    bodyChooseQuoteItems: {
                        cD_COTACAO: cdQuotation,
                        cD_PEDIDO: selectedCar.CD_PEDIDO,
                        customerId: selectedCar.CD_PESSOA,
                        quoteItemsChoose: [{
                            cD_COTACAO_ITEM: parseFloat(cdQuotationItem),
                            cD_PRODUTO: codPlane,
                            nR_TIPO_PRODUTO: nrTypeProduct
                        }]
                    }
                });
                handlePostCancelChange({
                    cD_COTACAO: cdQuotation,
                    cD_PESSOA: selectedCar.CD_PESSOA,
                    cD_PEDIDO: selectedCar.CD_PEDIDO
                });
            } else {
                let auxDsProducts = 'RCF-V:';
                productsSeguro?.map((value, index) => value.split('R$')[1] && (auxDsProducts = auxDsProducts.concat(` ${index !== 0 ? '/ ' : ''}R$${value.split('R$')[1]}`)));

                handlePostValidateChoose({
                    body: {
                        cD_PEDIDO: selectedCar.CD_PEDIDO,
                        cD_PRODUTO: codPlane
                    },
                    bodyCart: {
                        name: titleProduct,
                        codPlane,
                        percentageIndem,
                        price,
                        cents,
                        cdQuotationItem,
                        nrTypeProduct,
                        cdQuotation,
                        VL_COMISSAO
                    },
                    isWebView
                });

                handleProductCart({
                    bodyBase: {
                        cD_COTACAO: cdQuotation,
                        cD_PEDIDO: selectedCar.CD_PEDIDO,
                        customerId: selectedCar.CD_PESSOA,
                    },
                    body: {
                        cD_COTACAO_ITEM: parseFloat(cdQuotationItem),
                        cD_PRODUTO: codPlane,
                        nM_PRODUTO: titleProduct,
                        nR_TIPO_PRODUTO: nrTypeProduct,
                        vL_TOTAL: vL_TOTAL,
                        nR_PORCENTAGEM_INDENIZACAO: percentageIndem,
                        dS_PRODUTO: productsSeguro ? auxDsProducts : ''
                    },
                    addProduct: false,
                    productPlan: true
                });
            }

        }

    }

    const handleClearTitle = () => {
        if (product) {
            return `Ituran Com Seguro ${isEv ? 'EV' : ''}`;
        } else if (isLight) {
            return isOne ? 'Ituran One' : 'Ituran com Seguro Light';
        } else {
            return 'Rastreador';
        }
    }

    const handleClearSubTitle = (NM_PRODUTO: string, isTracker: boolean, isEv: boolean, isLight: boolean) => {
        const typeProduct = isTracker ? 'Rastreador' : `Ituran com Seguro ${isEv ? 'EV' : ''}`;
        let auxString = NM_PRODUTO?.replace(typeProduct, '');

        if (isLight) {
            auxString = auxString?.replace(/Ituran com Seguro Light|[0-9]/g, '');

            if ([2940, 2942].indexOf(codPlane) >= 0) {
                return `Roubo e Furto${[2944, 2946].indexOf(codPlane) >= 0 ? ' Moto' : ''}`;
            }
        }

        return auxString;
    }

    const isTooltip = () => {
        const isProduct = ProductsIcs?.find(({ CD_PRODUTO, DS_TOOLTIP }) => (codPlane === CD_PRODUTO) && DS_TOOLTIP);

        if (isProduct) {
            return <Tooltip>{isProduct.DS_TOOLTIP}</Tooltip>
        }
    }

    useEffect(() => {
        if (dataValidateChoose) {
            setIsLoading(false);
        }
    }, [dataValidateChoose]);

    useEffect(() => {
        if ((dS_PRODUTO && (typeof productsSeguro === 'undefined'))) {
            const auxProducs: Array<String> = [];

            // eslint-disable-next-line array-callback-return
            dS_PRODUTO.map((text) => {
                (text.indexOf('Materiais') > 0 && (parseInt(text.replace(/[^0-9.]/g, '')) > 0)) && auxProducs.push(`Danos Materiais: R$ ${parseInt(text.replace(/[^0-9.]/g, ''))} mil`);
                (text.indexOf('Corporais') > 0 && (parseInt(text.replace(/[^0-9.]/g, '')) > 0)) && auxProducs.push(`Danos Corporais: R$ ${parseInt(text.replace(/[^0-9.]/g, ''))} mil`);
                ((text.indexOf('Morais') > 0) && (parseInt(text.replace(/[^0-9.]/g, '')) > 0)) && auxProducs.push(`Danos Morais: R$ ${parseInt(text.replace(/[^0-9.]/g, ''))} mil`);
            });

            auxProducs?.length > 0 && setProductsSeguro(auxProducs);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dS_PRODUTO]);

    return (
        <div style={{ position: 'relative' }}>
            {isOneExist && !isOne &&
                <BoxMui sx={{ marginTop: '2rem' }} />
            }
            {isLight &&
                <BoxMui sx={{
                    position: 'absolute',
                    top: '-12px',
                    left: '-11px',
                    zIndex: '1',
                    'svg': {
                        width: '100px',
                        height: 'auto'
                    }
                }}>
                    <IcNewProduct />
                </BoxMui>
            }
            <Box recommended={produtO_ATUAL ? 'active' : 'disable'} typeproduct={product ? 'activeContainer' : 'disableContainer'} isOne={isOne ? 'active' : 'disable'}>
                <div className='content-recommended'>
                    {produtO_ATUAL &&
                        <Typography fontSize={18} color="white" fontWeight={700}>
                            Este é o seu plano atual
                        </Typography>
                    }
                </div>
                {isOne &&
                    <BoxMui sx={{
                        width: '100%',
                        backgroundColor: '#0C1C33',
                        borderRadius: '.3125rem',
                        gap: '.2rem',
                        height: '2rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        'svg': {
                            width: '1rem',
                            height: '1rem',
                            marginBottom: '.1rem',
                            'path': {
                                fill: 'white'
                            }
                        }
                    }}>
                        <Typography fontSize={16} color="white" textAlign='center'>
                            Seguro de RC
                        </Typography>
                        <Tooltip>O seguro de Responsabilidade Civil do Ituran One garante a indenização em casos do veículo roubado/furtado que não haja a recuperação</Tooltip>
                    </BoxMui>
                }
                <div className='content-card'>
                    <Typography variant="subtitle2" paddingBottom='.3rem'>
                        {handleClearTitle()}
                    </Typography>
                    <Typography variant="h6" fontWeight={700} sx={{ height: '1.5rem' }}>
                        {handleClearSubTitle(titleProduct, !product, isEv, isLight)}
                        {isTooltip()}
                    </Typography>
                    <PriceCard produtO_ATUAL={produtO_ATUAL} product={product} price={price} cents={cents} priceYearly={priceYearly} installationValue={0} />
                    <BoxMui sx={{
                        'button': {
                            minWidth: '8rem',
                            height: '2.5rem'
                        }
                    }}>
                        <ButtonRectangle disabled={produtO_ATUAL} name='CONTRATAR' onClick={() => handlerHireValidate()} />
                    </BoxMui>
                    <BoxList>
                        <ul>
                            {listWithoutPlan.map(({ title, covering }, index) => (
                                <li key={index}
                                    style={{
                                        paddingTop: '1px',
                                        gap: '6px',
                                        padding: '0 .7rem',
                                        height: `${(!product ? (isLight ? [1, 4] : [1, 6, 7]) : [5, 10]).indexOf(index) >= 0 ? '76px' : '35px'} `,
                                        background: (index % 2 !== 0) ? 'transparent' : 'rgba(227, 233, 242, 0.45)',
                                        borderBottom: (index % 2 !== 0) ? 'none' : '1px solid #E3E9F2'
                                    }}>
                                    {isLight && (index === 1) ?
                                        <BoxMui width='100%'>
                                            <BoxMui sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', columnGap: '6px', textAlign: 'left', marginBottom: '.4rem' }}>
                                                <CheckCircleIcon sx={{ fontSize: 18 }} color="secondary" />
                                                <Typography variant="body2" color="primary.main" dangerouslySetInnerHTML={{ __html: title }}></Typography>
                                            </BoxMui>
                                            {productsCard?.length > 1 ?
                                                <>
                                                    <Typography sx={{
                                                        textAlign: 'center !important',
                                                        display: 'block !important',
                                                        fontSize: '.625rem',
                                                        marginBottom: { xs: '.2rem', md: '.5rem' }
                                                    }}>
                                                        Faça a sua escolha
                                                    </Typography>
                                                    <BoxMui display='flex' sx={{ justifyContent: { xs: 'space-evenly', md: 'space-between' } }}>
                                                        {productsCard?.map(({ nR_PORCENTAGEM_INDENIZACAO, cD_PRODUTO, vL_TOTAL }, index) =>
                                                            <BoxMui key={index} display='flex' textAlign='center' flexDirection='column' rowGap='.5rem'>
                                                                <ButtonCustom
                                                                    variant='outlined'
                                                                    selected={cD_PRODUTO === codPlane ? 'active' : 'disabled'}
                                                                    onClick={() => handleStateActive(codPlane, cD_PRODUTO)}>
                                                                    {nR_PORCENTAGEM_INDENIZACAO}%
                                                                </ButtonCustom>
                                                                <Typography fontSize={'.875rem'} color="grey.300" component='span' fontWeight={600}>
                                                                    {vL_TOTAL} / mês
                                                                </Typography>
                                                            </BoxMui>
                                                        )}
                                                    </BoxMui>
                                                </>
                                                :
                                                <Typography fontSize={'.8125rem'} color="primary.main" component='span' fontWeight={700}>
                                                    {percentageIndem}%
                                                </Typography>
                                            }
                                        </BoxMui>
                                        :
                                        covering ?
                                            (!product ? isLight ? [4] : [6] : [5]).indexOf(index) >= 0 ?
                                                <BoxMui sx={{ display: 'flex', alignItems: 'center', columnGap: '6px', textAlign: { xs: 'left', md: 'center' } }}>
                                                    <BoxMui sx={{ display: { xs: 'flex', md: 'none' } }}>
                                                        <CheckCircleIcon sx={{ fontSize: 18 }} color="secondary" />
                                                    </BoxMui>
                                                    <BoxMui sx={{ display: 'grid', 'span': { fontSize: '.75rem', lineHeight: '105%' }, gap: '.2rem' }}>
                                                        <Typography sx={{ display: { xs: 'flex', md: 'none' } }} variant="body2" color={covering ? "primary.main" : "grey.200"} dangerouslySetInnerHTML={{ __html: title }}></Typography>
                                                        {productsSeguro?.map((text, index) =>
                                                            <span key={index}>
                                                                {text}
                                                            </span>
                                                        )}
                                                    </BoxMui>
                                                </BoxMui>
                                                : product && (index === 1) ?
                                                    <BoxMui sx={{ display: 'flex', alignItems: 'center', columnGap: '6px' }}>
                                                        <BoxMui sx={{ display: { xs: 'flex', md: 'none' } }}>
                                                            <CheckCircleIcon sx={{ fontSize: 18 }} color="secondary" />
                                                        </BoxMui>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: '.75rem', md: '.8125rem' },
                                                                fontWeight: { xs: 600, md: 400 },
                                                                display: { xs: 'block', md: 'none' }
                                                            }}
                                                            color="primary.main"
                                                            component='span'>
                                                            Indenização de {percentageIndem}% FIPE
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: '.75rem', md: '.8125rem' },
                                                                fontWeight: { xs: 600, md: 400 },
                                                                display: { xs: 'none', md: 'block' }
                                                            }}
                                                            color="primary.main"
                                                            component='span'>
                                                            {percentageIndem}%
                                                        </Typography>
                                                    </BoxMui>
                                                    :
                                                    <CheckCircleIcon sx={{ fontSize: 18 }} color="secondary" />
                                            : product && (index === 1) ?
                                                <BoxMui sx={{ display: 'flex', alignItems: 'center', columnGap: '6px' }}>
                                                    <BoxMui sx={{ display: 'flex', alignItems: 'center', columnGap: '6px' }}>
                                                        <BoxMui sx={{ display: { xs: 'flex', md: 'none' } }}>
                                                            <CheckCircleIcon sx={{ fontSize: 18 }} color="secondary" />
                                                        </BoxMui>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: '.75rem', md: '.8125rem' },
                                                                fontWeight: { xs: 600, md: 400 },
                                                                display: { xs: 'block', md: 'none' }
                                                            }}
                                                            color="primary.main"
                                                            component='span'>
                                                            Indenização de {percentageIndem}% FIPE
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontSize: { xs: '.75rem', md: '.8125rem' },
                                                                fontWeight: { xs: 600, md: 400 },
                                                                display: { xs: 'none', md: 'block' }
                                                            }}
                                                            color="primary.main"
                                                            component='span'>
                                                            {percentageIndem}%
                                                        </Typography>
                                                    </BoxMui>
                                                </BoxMui>
                                                :
                                                <>
                                                    <CancelIcon sx={{ color: "error.main", fontSize: 18 }} />
                                                    {(!product ? (isLight ? [4] : [6]) : [5]).indexOf(index) >= 0 &&
                                                        <Typography variant="body2" color={covering ? "primary.main" : "grey.200"} dangerouslySetInnerHTML={{ __html: title }}></Typography>
                                                    }
                                                </>
                                    }
                                    {!product && [7].indexOf(index) >= 0 ?
                                        <Typography variant="body2" color={covering ? "primary.main" : "grey.200"} dangerouslySetInnerHTML={{ __html: title }}></Typography>
                                        : (!product ? (isLight ? (covering ? [4] : [1]) : [6]) : [1, 5]).indexOf(index) < 0 &&
                                        <Typography variant="body2" color={covering ? "primary.main" : "grey.200"}>
                                            {title}
                                        </Typography>
                                    }
                                </li>
                            ))}
                        </ul>
                    </BoxList>
                </div>
            </Box>

            <Modal open={isOpenModalIsLight}>
                <BoxMui sx={{ textAlign: 'center', padding: '2rem', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '20rem' } }}>
                    <ContendModal className='modal-start-stop'>
                        <Typography variant="h6" fontWeight={400}>
                            O plano escolhido contempla
                        </Typography>

                        <Typography variant="h6" fontWeight={700}>
                            <strong>
                                {percentageIndem}%
                            </strong>
                            <br />
                            TABELA FIPE
                        </Typography>

                        <BoxMui sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '.75rem' }}>
                            <ButtonRectangle name='CONTINUAR' type='button' loadingBtn={isLoading} onClick={() => handlerHire()} />
                            <ButtonRectangle selected={false} name='CANCELAR' type='button' onClick={() => setIsOpenModalIsLight(false)} />
                        </BoxMui>
                    </ContendModal>
                </BoxMui>
            </Modal>
        </div>
    )
}

export default Card;